import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import LoginContainer from './modules/auth/container/LoginContainer';
import AccessControl from './modules/auth/component/AccessControl';
import Layout from './Layout';
import PropConfigListContainer from './modules/propConfig/container/PropConfigListContainer';
import PropContainerDetailContainer from './modules/propConfig/container/PropConfigDetailContainer';
import SysStoreListContainer from './modules/sysStore/container/SysStoreListContainer';
import SysStoreDetailContainer from './modules/sysStore/container/SysStoreDetailContainer';
import IntFileListContainer from './modules/intFile/container/IntFileListContainer';
import IntFileDetailContainer from './modules/intFile/container/IntFileDetailContainer';
import IntFileLogDetailContainer from './modules/intFileLog/container/IntFileLogDetailContainer';
import IntFileLogListContainer from './modules/intFileLog/container/IntFileLogListContainer';
import PosJournalListContainer from './modules/posJournal/container/PosJournalListContainer';
import PosJournalDetailContainer from './modules/posJournal/container/PosJournalDetailContainer';
import FileUploadListContainer from './modules/fileUpload/container/FileUploadListContainer';
import FileUploadDetailContainer from './modules/fileUpload/container/FileUploadDetailContainer';
import MediaDirectoryTreeContainer from './modules/mediaManagement/container/MediaDirectoryTreeContainer';
import UsersListContainer from './modules/users/container/UsersListContainer';
import StoreItemsListContainer from './modules/inventory/container/StoreItemsListContainer';
import StoreItemDetailContainer from './modules/inventory/container/StoreItemDetailContainer';
import SysApiLogDetailContainer from './modules/sysApilog/container/SysApiLogDetailContainer';
import SysApiLogsListContainer from './modules/sysApilog/container/SysApiLogListContainer';
import SysEventsListContainer from './modules/sysEvents/container/SysEventsListContainer';
import SysEventsDetailsContainer from './modules/sysEvents/container/SysEventsDetailsContainer';
import ExportLogsContainer from './modules/devopsTool/container/ExportLogsContainer';
import IntOutBoundFileListContainer from './modules/intOutboundFile/container/IntOutBoundFileListContainer';
import IntOutBoundFileDetailContainer from './modules/intOutboundFile/container/IntOutBoundFileDetailContainer';
import CleanUpTableContainer from './modules/devopsTool/container/CleanUpTableContainer';
import CleanUpDiskContainer from './modules/devopsTool/container/CleanUpDiskContainer';
import CleanUpLogsContainer from './modules/devopsTool/container/CleanUpLogsContainer';
import LogsParserContainer from './modules/devopsTool/container/LogsParserContainer';
import SysErrorCodesListContainer from './modules/sysErrorCode/container/SysErrorCodeListContainer';
import SysErrorCodeDetailsContainer from './modules/sysErrorCode/container/SysErrorCodeDetailContainer';
import { useSelector } from 'react-redux';
import Loader from './components/Loader';
import SysAppLoggerListContainer from './modules/sysAppLogger/container/SysAppLoggerContainer';
import SysAppLoggerDetailsContainer from './modules/sysAppLogger/container/SysAppLoggerDetailContainer';
import GlobalTooltip from './components/GlobalTooltip';
import DashboardContainer from './modules/Dashboard/container/DashboardContainer';
import RolesListContainer from './modules/roles/container/RolesListContainer';
import StoreSystemIdListContainer from './modules/storeSystemIdConfig/container/StoreSystemIdListConatiner';
import StoreSystemIdDetailsContainer from './modules/storeSystemIdConfig/container/StoreSystemIdDetailsConatiner';


const AuthRequiredContainer = () => {

    const loading = useSelector((state) => state.ui.loading);  // Accessing loading state from Redux store

    return (
        <>
            <GlobalTooltip />
            {loading && <Loader />} {/* Show loader if loading is true */}
            <Layout>
                <AccessControl>
                    <Routes>

                        <Route
                            path='dashboard'
                            element={ <DashboardContainer pageId="M01"/>}
                        >
                        </Route>
                        
                        <Route
                            path="/system-store"
                            element={<SysStoreListContainer pageId="M02-1"/>}
                        />
                        <Route
                            path="/system-store/detail"
                            element={<SysStoreDetailContainer pageId="M02-1"/>}
                        />
                        
                        <Route
                            path="/prop-confg"
                            element={<PropConfigListContainer pageId="M02-2"/>}
                        />
                        <Route
                            path="/prop-confg/detail"
                            element={<PropContainerDetailContainer pageId="M02-2"/>}
                        />
                        
                        <Route
                            path="/integration-file"
                            element={<IntFileListContainer pageId="M02-3"/>}
                        />
                        <Route
                            path="/integration-file/detail"
                            element={<IntFileDetailContainer pageId="M02-3"/>}
                        />
                        
                        <Route
                            path="/integration-file-log"
                            element={<IntFileLogListContainer pageId="M02-4"/>}
                        />
                        <Route
                            path="/integration-file-log/detail"
                            element={<IntFileLogDetailContainer pageId="M02-4"/>}
                        />

                        <Route
                            path="/int-outbound-file"
                            element={<IntOutBoundFileListContainer pageId="M02-5"/>}
                        />
                        <Route
                            path="/int-outbound-file/detail"
                            element={<IntOutBoundFileDetailContainer pageId="M02-5"/>}
                        />

                        <Route
                            path="/file-upload-queue"
                            element={<FileUploadListContainer pageId="M02-6"/>}
                        />
                        <Route
                            path="/file-upload-queue/detail"
                            element={<FileUploadDetailContainer pageId="M02-6"/>}
                        />

                        <Route
                            path="/pos-journal"
                            element={<PosJournalListContainer pageId="M02-7"/>}
                            data="M01"
                        />
                        <Route
                            path="/pos-journal/detail"
                            element={<PosJournalDetailContainer pageId="M02-7"/>}
                        />

                        <Route
                            path="/store-items"
                            element={<StoreItemsListContainer pageId="M02-8" />}
                        />
                        <Route
                            path="/store-item/details"
                            element={<StoreItemDetailContainer pageId="M02-8" />}
                        />

                        <Route
                            path="/sys-apilogs"
                            element={<SysApiLogsListContainer  pageId="M02-9" />}
                        />
                        <Route
                            path="/sys-apilogs/details"
                            element={<SysApiLogDetailContainer  pageId="M02-9" />}
                        />

                        <Route
                            path="/sys-events"
                            element={<SysEventsListContainer pageId="M02-10" />}
                        />
                        <Route
                            path="/sys-events/details"
                            element={<SysEventsDetailsContainer  pageId="M02-10" />}
                        />
                    
                        <Route
                            path="/media-management"
                            element={<MediaDirectoryTreeContainer pageId="M03-1"/>}
                        />

                        <Route
                            path="/users-management"
                            element={<UsersListContainer pageId="M03-2"/>}
                        />
                        
                        <Route
                            path="/roles-management"
                            element={<RolesListContainer pageId="M03-5"/>}
                        />

                        <Route
                            path="/system-error-codes"
                            element={<SysErrorCodesListContainer pageId="M03-3" />}
                        />
                        <Route
                            path="/system-error-codes/details"
                            element={<SysErrorCodeDetailsContainer pageId="M03-3" />}
                        />

                        <Route
                            path="/system-app-logger"
                            element={<SysAppLoggerListContainer pageId="M03-4" />}
                        />
                        <Route
                            path="/system-app-logger/detail"
                            element={<SysAppLoggerDetailsContainer  pageId="M03-4"/>}
                        />

                        <Route
                            path="/store-system-id-config"
                            element={<StoreSystemIdListContainer pageId="M03-5" />}
                        />
                        <Route
                            path="/store-system-id-config/detail"
                            element={<StoreSystemIdDetailsContainer pageId="M03-5"/>}
                        />

                        <Route
                            path="/devopstool/export/:type"
                            element={<ExportLogsContainer/>}
                        />
                        <Route
                            path="/devopstool/cleanup-table"
                            element={<CleanUpTableContainer/>}
                        />

                         <Route
                            path="/devopstool/cleanup-log"
                            element={<CleanUpLogsContainer pageId="M04-4" />}
                        />
                        
                        <Route
                            path="/devopstool/logs-parser"
                            element={<LogsParserContainer pageId="M04-5" />}
                        />

                        <Route
                            path="/devopstool/cleanup-disk"
                            element={<CleanUpDiskContainer/>}
                        />
                       

                    </Routes>
                </AccessControl>
            </Layout>
        </>
    );
};

const AppRoutes = () => (
    <BrowserRouter>
        <Routes>
            <Route path="/login" element={<LoginContainer />} />
            <Route element={<AuthRequiredContainer />} path="/ui/*" />
            {/* Redirect root URL to /login */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            
            {/* Catch-all route to redirect to /login */}
            <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
    </BrowserRouter>
);

export default AppRoutes;
